import axios from 'axios'
import apiCodes from './apiCodes'
import storage from '@/api/storage'
import emitter, { events } from './eventBus'
import { useAuthStore } from '@/stores/auth'

const req = async (reqName, method, payload = {}) => {
  const authStore = useAuthStore()
  const { headers, requestParam } = payload
  try {
    const response = await axios({
      responseType: 'json',
      method,
      url: `https://dispatcher.r1.robstor.com/api/${reqName}`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        ...authStore.authHeader,
        ...headers,
      },
      data: requestParam, // NB: FormData не сериализуется в JSON
    })

    const { data } = response
    // console.log('response.data: ', JSON.stringify(response.data, 0, 2));
    const msg = {}

    // code 15 and 16
    if (data.code === apiCodes.wrongToken || data.code === apiCodes.wrongRefreshToken) {
      const error = new Error('Invalid token')
      emitter.emit(events.API_WRONG_TOKEN, { code: data.code, text: error.message })
      return response
    }
    // code 66
    if (data.code === apiCodes.tokenUpdate) {
      const session = storage.GET('r1_session')
      const updatedSession = {
        ...session,
        token: data.token,
      }
      authStore.authUser = updatedSession
      storage.SET('r1_session', updatedSession)
      const refresh = await req(reqName, method, payload)
      return refresh
    }

    if (data.code !== apiCodes.ok
      && data.code !== apiCodes.wrongToken
      && data.code !== apiCodes.wrongRefreshToken
    ) {
      msg.code = data.code
      // msg.text = data.result.txt ?? 'для этого кода нет описания'; // это для всего остального
      // msg.text = data.msg ?? 'для этого кода нет описания'; // это для логина
      // здесь надо проверять, если логин, то будет не в резалте, а msg или вообще ничего не будет при коде 52
      if (data.code === apiCodes.emptyLoginOrPassword || data.route === 'login') {
        msg.desc = { text: 'Неверный логин или пароль' }
      }
      else {
        msg.desc = data.result
      }

      emitter.emit(events.API_ERROR, msg)
      return response
    }

    // desc = result field from response obj
    emitter.emit(events.API_SUCCESS, { code: data.code, desc: data.result })
    return response
  }
  catch (error) {
    emitter.emit(events.AXIOS_ERROR, { code: error.code, text: error.message })
  }
}

export default {
  request: (reqName, method, payload) => req(reqName, method, payload),
  get: (reqName, payload) => req(reqName, 'get', payload),
  post: (reqName, payload) => req(reqName, 'post', payload),
}
